<template>
  <div class="payBox">
    <div class="payTit">
      请选择以下支付方式付款
    </div>
    <div class="payCon" v-if="paymentType">
      <div class="tabTit">
        <p
          @click="form.payType = 2"
          :class="form.payType == 2 ? 'activate' : ''"
          v-if="(paymentType == 2 || paymentType == 3) && bigFlag != 1"
        >
          <i class="iconfont icon-xingzhuangjiehe"></i>
          <img src="@/assets/images/product/payxxbj.png" alt="" />线下支付
        </p>
        <p
          @click="form.payType = 4"
          :class="form.payType == 4 ? 'activate' : ''"
          v-if="bigFlag == 1"
        >
          <i class="iconfont icon-xingzhuangjiehe"></i>
          <img src="@/assets/images/product/issue_num.png" alt="" />积分支付
        </p>
        <p
          @click="form.payType = 1"
          :class="form.payType == 1 ? 'activate' : ''"
          v-if="paymentType == 1 || paymentType == 3"
        >
          <i class="iconfont icon-xingzhuangjiehe"></i>
          <img src="@/assets/images/product/payxsbj.png" alt="" />线上支付
        </p>
      </div>
      <div class="tabCon">
        <div v-show="form.payType == 2">
          <p class="tabPayTit">
            保费支付账号：
            <span>
              <i class="el-icon-warning-outline"></i>
              转票限制金额100万，不允许对私转款
            </span>
          </p>
          <div>
            <p>账户：{{ bank.bank_no }}</p>
            <p>开户行：{{ bank.bank_title }}</p>
            <p>账户名：{{ bank.bank_name }}</p>
            <!-- <p>财务余额：{{ balance }}</p> -->
          </div>
          <p class="tabPayTit">
            缴费凭证上传：
          </p>
          <el-form
            :model="form"
            :rules="rules"
            ref="form"
            size="small"
            label-width="130px"
          >
            <el-form-item label="支付人姓名：" prop="payName">
              <el-input
                v-model="form.payName"
                placeholder="请输入实际付款人"
                style="width:320px;"
              ></el-input>
            </el-form-item>
            <el-form-item label="身份证号：" prop="payCardCode">
              <el-input
                v-model="form.payCardCode"
                placeholder="请输入身份证号"
                style="width:320px;"
              ></el-input>
            </el-form-item>
            <el-form-item label="上传凭证：" prop="payVoucher">
              <el-upload
                drag
                action="/api/upload/upload"
                name="file"
                multiple
                :http-request="upload"
                :on-remove="removeFile"
                accept=".jpg,.png,.jpgp"
              >
                <img src="@/assets/images/product/upload.png" alt="" />
                <div>
                  <div class="el-upload__text">
                    将支付凭证拖到此处，或 <em>点击上传</em>
                  </div>
                  <p>上传图片最大不得超过100M，只能上传jpg/png/jpeg文件</p>
                </div>
              </el-upload>
            </el-form-item>
          </el-form>
          <el-button type="primary" size="small" @click="gopay(2)">
            提交审核
          </el-button>
        </div>
        <div v-show="form.payType == 4">
          <p class="tabPayTit">
            财务系统账号：
            <span>
              <i class="el-icon-warning-outline"></i>
              请先确认财务系统有足够扣除的余额
            </span>
          </p>
          <div>
            <p>财务余额：共 {{ balance.balance }} 元，锁定：{{ balance.lock }} 元</p>
          </div>
          <el-button type="primary" size="small" @click="gopay(4)">
            提交审核
          </el-button>
        </div>
        <div v-show="form.payType == 1">
          <!-- //京东安联方案线上支付判断 -->
          <div
            class="payMethodBox"
            v-if="productCode == 'P2104199545' || productCode == 'P2104199546'"
          >
            <el-radio-group v-model="payMethod">
              <el-radio label="wxpayPc" border>
                <img src="@/assets/images/product/wx.png" alt="" /> 微信扫码支付
              </el-radio>
              <el-radio label="alipay" border>
                <img src="@/assets/images/product/zfb.png" alt="" />
                支付宝扫码支付
              </el-radio>
              <el-radio label="JDPayPC02" border>
                <img src="@/assets/images/product/jd.png" alt="" />
                京东收银台支付
              </el-radio>
            </el-radio-group>
          </div>
          <div class="onLinePay">
            <img src="@/assets/images/product/xspaybg.png" alt="" />
            <p>您要去第三方平台进行支付！</p>
            <template v-if="protype">
              <!-- <div>
                <div class="proMyR">
                  本保险合同保费是否由投保人 （<span>{{ protype }} </span>）
                  企业账户支付
                </div>
                <div class="proMyL">
                  <el-radio-group v-model="proMyis">
                    <el-radio label="0" border>
                      是
                    </el-radio>
                    <el-radio label="1" border>
                      否
                    </el-radio>
                  </el-radio-group>
                </div>
              </div> -->
              <el-form
                :model="form2"
                :rules="rules2"
                ref="form2"
                size="small"
                label-width="200px"
                label-position="right"
                style="width: 600px;margin: auto;"
                v-if="proMyis == 1"
              >
                <el-form-item label="支付人姓名：" prop="payName">
                  <el-input
                    v-model="form2.payName"
                    placeholder="请输入实际付款人"
                  ></el-input>
                </el-form-item>
                <el-form-item label="身份证号：" prop="payCardCode">
                  <el-input
                    v-model="form2.payCardCode"
                    placeholder="请输入身份证号"
                  ></el-input>
                </el-form-item>
                <el-form-item label="代付原因：">
                  <el-input
                    v-model="form2.payReason"
                    placeholder="请输入代付原因，非代付请忽略"
                  ></el-input>
                </el-form-item>
                <el-form-item label="代付人与投保企业关系：">
                  <el-input
                    v-model="form2.payRelationship"
                    placeholder="请输入代付人与投保企业关系，非代付请忽略"
                  ></el-input>
                </el-form-item>
              </el-form>
              <el-button type="primary" size="small" @click="mygoonLinePay">
                去支付
              </el-button>
            </template>
            <el-button type="primary" size="small" @click="goonLinePay" v-else>
              去支付{{ protype }}
            </el-button>
          </div>
        </div>
      </div>
      <!-- 支付宝收款码 -->
      <div style="margin: 0 auto; width:600px;" v-if="
            productId == '1001551' ||
            productId == '1001642' ||
            productId == '1001624' ||
            productId == '1001646' ||
            productId == '1001575' ||
            productId == '1001599' ||
            productId == '1001296' ||
            productId == '1001650' ||
            productId == '1001530' ||
            productId == '1001181' ||
            productId == '1001673' ||
            productId == '1001674' ||
            productId == '1001675' ||
            productId == '1001654' ||
            productId == '1001655' ||
            productId == '1001656'
        ">
        <img src="@/assets/images/alipay.png" width="600" height="auto" alt="">
    </div>
    </div>
  </div>
</template>
<script>
import { upload } from "@/api/public";
import { policyPay } from "@/api/insure";
import { correctionPay } from "@/api/check";
import { getOrderInfo } from "@/api/guarantee";
import verify from "@/utils/verify";
export default {
  name: "pay",
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    numId: {
      type: [Number, String],
      required: true
    },
    type: {
      type: Number,
      default: 0
    },
    // 美亚使用
    protype: {}
  },
  data() {
    return {
      headerSelect: this.$store.state.headerSelect, //系统选择
      bank: "", //支付数据
      paymentType: "", //支付可选方式 1线上 2线下 3线上线下
      uploadTitBox: [], //记录上传的文件名，删除时使用
      payMethod: "wxpayPc", //京东安联线上支付使用 wxpayPc微信支付，alipay支付宝支付，JDPayPC02京东收银台
      productCode: "", //产品编号
      productId:'',
      proMyis: "1", //美亚的判断支付人线上支付是否是投保企业，
      balance:{},
      bigFlag:0,
      form: {
        payType: "2",
        payName: "",
        payCardCode: "",
        payVoucher: []
      },
      // 美亚使用没有啥用
      form2: {
        payType: "2",
        payName: "",
        payCardCode: "",
        payReason: "",
        payRelationship: ""
      },
      rules: {
        payName: [
          { required: true, message: "请输入支付人姓名", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback();
              } else {
                callback(new Error("姓名只可以是中文!"));
              }
            },
            trigger: "blur"
          }
        ],
        payCardCode: [
          {
            validator: (rule, value, callback) => {
              let val = verify.idNoFormatCheck(value);
              if (value != "") {
                if (!val) {
                  return callback(new Error("身份证号码不正确"));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        payVoucher: [
          {
            required: true,
            message: "请上传支付凭证",
            trigger: ["blur", "change"]
          }
        ]
      },
      rules2: {
        payName: [
          { required: true, message: "请输入支付人姓名", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback();
              } else {
                callback(new Error("姓名只可以是中文!"));
              }
            },
            trigger: "blur"
          }
        ],
        payCardCode: [
          {
            required: true,
            message: "请输入支付人身份证号码",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              let val = verify.idNoFormatCheck(value);
              if (value != "") {
                if (!val) {
                  return callback(new Error("身份证号码不正确"));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {
    this.getOrderInfo();
  },
  methods: {
    //上传文件
    upload(e) {
      console.log(e);
      let that = this;
      let form = new FormData();
      form.append("file", e.file);
      form.append("folder", "other");
      upload(form)
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.form.payVoucher.push(res.data.fileUrl);
            that.uploadTitBox.push(res.data.fileName);
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 移除
    removeFile(e, list) {
      console.log(e, list);
      let _index = this.uploadTitBox.indexOf(e.name);
      this.uploadTitBox.splice(_index, 1);
      this.form.payVoucher.splice(_index, 1);
    },
    //支付线下
    gopay(payType) {
      let that = this;
      this.$refs.form.validate(valid => {
        if (!valid && payType == 2) {
            console.log("error submit!!");
            return false;
        } else {
          let _data = this.form;
          let loadind = that.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          if (that.type == 0) {
            _data.numId = that.id;
            policyPay(_data)
              .then(function(res) {
                console.log(res);
                loadind.close();
                if (res.code == 1) {
                  that.$message.success(res.msg);
                  if (that.headerSelect == 1) {
                    that.$router.push({
                      path: "/guarantee"
                    });
                  } else {
                    that.$router.push({
                      path: "/hr/staff"
                    });
                  }
                } else {
                  that.$message.error(res.msg);
                }
              })
              .catch(function(error) {
                console.log(error);
              });
          } else {
            _data.changeId = that.id;
            correctionPay(_data)
              .then(function(res) {
                loadind.close();
                console.log(res);
                if (res.code == 1) {
                  that.$message.success(res.msg);
                  if (that.headerSelect == 1) {
                    that.$router.push({
                      path: "/check"
                    });
                  } else {
                    that.$router.push({
                      path: "/hr/staff"
                    });
                  }
                } else {
                  that.$message.error(res.msg);
                }
              })
              .catch(function(error) {
                console.log(error);
              });
          }
        }
      });
    },
    // 线上支付
    goonLinePay() {
      let that = this;
      let loadind = that.$loading({
        lock: true,
        text: "支付转跳中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      if (that.type == 0) {
        let _data = {
          payType: that.form.payType,
          numId: that.id
        };
        if (
          //京东安联方案线上支付判断
          that.productCode == "P2104199545" ||
          that.productCode == "P2104199546"
        ) {
          _data.payMethod = that.payMethod;
        }
        policyPay(_data)
          .then(function(res) {
            console.log(res);
            loadind.close();
            if (res.code == 1) {
              that.$message.success(res.msg);
              window.location.href = res.data.payUrl;
            } else {
              that.$message.error(res.msg);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      } else {
        //批改
        let _data = {
          payType: that.form.payType,
          changeId: that.id
        };
        if (
          //京东安联方案线上支付判断
          that.productCode == "P2104199545" ||
          that.productCode == "P2104199546"
        ) {
          _data.payMethod = that.payMethod;
        }
        correctionPay(_data)
          .then(function(res) {
            loadind.close();
            console.log(res);
            if (res.code == 1) {
              that.$message.success(res.msg);
              window.location.href = res.data.payUrl;
            } else {
              that.$message.error(res.msg);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    // 美亚线上支付
    mygoonLinePay() {
      let that = this;
      console.log(this.$refs.form2);
      this.$refs.form2.validate(valid => {
        console.log(valid);
        if (valid) {
          that.goonLinePay();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //获取订单详情
    getOrderInfo() {
      let that = this;
      getOrderInfo({ numId: this.numId })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.productId = res.data.product_id
            that.bank = res.data.payVoucher;
            that.paymentType = res.data.paymentMethod;
            that.productCode = res.data.productCode;
            that.balance = res.data.balance;
            that.bigFlag = res.data.bigFlag;
            if (that.paymentType == 2 || that.paymentType == 3) {
              that.form.payType = "2";
            } else {
              that.form.payType = "1";
            }
            if(that.bigFlag == 1){
                that.form.payType = 4;
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  watch: {
    "form.payVoucher"(e) {
      console.log(e);
      this.$refs.form.validateField("payVoucher");
    }
  }
};
</script>
<style lang="scss">
.payBox {
  padding: 0 100px;
  & > .payTit {
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    line-height: 22px;
    margin: 0 0 25px;
  }
  & > .payCon {
    .tabTit {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      & > p {
        position: relative;
        background: #ffffff;
        border-radius: 5px;
        border: 1px solid #e2e2e2;
        font-size: 22px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.65);
        line-height: 30px;
        margin: 0;
        padding: 25px;
        width: 200px;
        text-align: center;
        cursor: pointer;
        transition: all 0.25s;
        img {
          vertical-align: middle;
          margin-right: 15px;
        }
        i {
          color: #2d8aee;
          position: absolute;
          top: -7px;
          right: 0;
          opacity: 0;
          transition: all 0.25s;
        }
      }
      & > p.activate {
        box-shadow: 3px 2px 6px 0px rgba(45, 138, 238, 0.25);
        border: 1px solid #2d8aee;
        i {
          opacity: 1;
        }
      }
      & > p + p {
        margin-left: 25px;
      }
    }
    .tabCon {
      .tabPayTit {
        font-size: 16px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
        margin: 35px 0 15px;
        span {
          background: #fdf2d4;
          border-radius: 3px;
          display: inline-block;
          font-size: 14px;
          font-weight: 400;
          color: #f86c07;
          line-height: 20px;
          margin-left: 15px;
          padding: 6px 15px 6px 20px;
          i {
            font-size: 16px;
            color: #ee4039;
          }
        }
      }
      .tabPayTit:before {
        content: "";
        width: 8px;
        height: 8px;
        border: 2px solid #2d8aee;
        margin-right: 10px;
        display: inline-block;
        transform: rotate(45deg);
        margin-bottom: 1px;
      }
      .tabPayTit + div {
        margin-left: 25px;
        p {
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          line-height: 30px;
          margin: 0;
        }
      }
      .el-form-item {
        margin-bottom: 25px;
        .el-form-item__label {
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
        }
      }
      .el-upload {
        width: 100%;
        .el-upload-dragger {
          border: 1px solid #dedede;
          width: 100%;
          height: 180px;
          background: #fcfcfc;
          display: flex;
          justify-content: center;
          align-items: center;
          img + div {
            margin: 0 50px;
            .el-upload__text {
              font-size: 16px;
              font-weight: 400;
              color: #000000;
              line-height: 22px;
            }
            p {
              font-size: 12px;
              margin: 5px 0 0;
              font-weight: 400;
              color: #f86c07;
              line-height: 17px;
            }
          }
        }
      }
      & > div .el-button {
        margin: 35px auto 60px;
        display: block;
        width: 100px;
      }
      & > div .onLinePay {
        text-align: center;
        img {
          margin: 60px 30px 15px;
        }
        p {
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 28px;
          margin: 0;
        }
        .el-button {
          margin: 35px auto 60px;
          display: block;
          width: 200px;
        }
        .proMyR {
          color: rgba(0, 0, 0, 0.85);
          padding: 15px 0;
          font-size: 18px;
          span {
            color: rgba(0, 0, 0, 1);
          }
        }
        .proMyL {
          padding: 15px 0 25px;
        }
      }
      .payMethodBox {
        padding: 25px 0 50px;
        .el-radio-group {
          .el-radio {
            padding: 0;
            .el-radio__input {
              display: none;
            }
            .el-radio__label {
              padding: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100%;
              padding: 0 15px;
              img {
                width: 30px;
                margin-right: 5px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
